// Warning: Currently can't handle pre-release versions like 1.0.0-alpha correctly, see tests
const isGreaterSemVersionThan = (appVersion: string | undefined, reference: string) => {
  if (!appVersion) {
    return false;
  }
  // 1: appVersion > reference; -1: appVersion < reference; 0: appVersion === reference
  const comparisonValue = appVersion.localeCompare(reference, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
  return comparisonValue >= 0;
};

export default isGreaterSemVersionThan;
